export default "__VITE_ASSET__ipeZ9EzG__"